// src/store/gymviz/gymvizSlice.js
// Deliberately has no create thunk: the create response carries the one-time
// admin_password, which must never pass through Redux. The form calls
// apiService.createGymVizProvisioning directly and keeps the response local.
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiService from '../../services/api.service';
import { errorMessage } from '../errorMessage';

const thunk = (type, call) =>
  createAsyncThunk(`gymviz/${type}`, async (arg, { rejectWithValue }) => {
    try {
      return await call(arg);
    } catch (error) {
      return rejectWithValue(errorMessage(error));
    }
  });

export const fetchGymVizProvisionings = thunk('fetchAll', async (params = {}) => {
  const { data } = await apiService.getGymVizProvisionings(params);
  return data.results ?? data;
});
export const fetchGymVizProvisioningById = thunk('fetchById', async (id) =>
  (await apiService.getGymVizProvisioning(id)).data);

const initialState = { items: [], current: null, isLoading: false, error: null };

const gymvizSlice = createSlice({
  name: 'gymviz',
  initialState,
  reducers: {
    clearError: (state) => { state.error = null; },
    clearCurrent: (state) => { state.current = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGymVizProvisionings.fulfilled, (state, { payload }) => { state.items = payload; })
      .addCase(fetchGymVizProvisioningById.fulfilled, (state, { payload }) => { state.current = payload; })
      .addMatcher((a) => a.type.startsWith('gymviz/') && a.type.endsWith('/pending'), (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher((a) => a.type.startsWith('gymviz/') && a.type.endsWith('/fulfilled'), (state) => {
        state.isLoading = false;
      })
      .addMatcher((a) => a.type.startsWith('gymviz/') && a.type.endsWith('/rejected'), (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, clearCurrent } = gymvizSlice.actions;
export default gymvizSlice.reducer;
